module.exports = __webpack_public_path__ + "static/media/Logo-SORIANA.0afe2b9f.png";